import { useNavigate } from "@tanstack/react-router"
import { ChevronsUpDown } from "lucide-react"
import { useTranslation } from "react-i18next"
import { useAuth } from "@/entities/auth"
import { useUserProfile } from "@/entities/profile"
import { Avatar, AvatarFallback, AvatarImage } from "@/shared/ui/avatar"
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@/shared/ui/dropdown-menu"
import { Skeleton } from "@/shared/ui/skeleton"

const NAME_SEPARATOR = " "

export function SidebarUserProfile() {
	const { t } = useTranslation()
	const { logout } = useAuth()
	const navigate = useNavigate()
	const { data: userInfo, isLoading: isUserInfoLoading } = useUserProfile()
	const nameParts = [userInfo?.profile.name, userInfo?.profile.surname]
	const initials = nameParts
		.map((n) => n?.[0])
		.join("")
		.toUpperCase()
		.slice(0, 2)

	return (
		<div className="flex items-center justify-between p-1">
			<DropdownMenu>
				<DropdownMenuTrigger asChild>
					<div className="flex items-center gap-2 min-w-0 flex-1 hover:bg-accent rounded-md py-1">
						<Avatar>
							{userInfo?.profile && ( // Should be avatar instead, but we don't have that yet
								<AvatarImage alt={userInfo?.profile.name} />
							)}
							<AvatarFallback>{initials}</AvatarFallback>
						</Avatar>
						{isUserInfoLoading ? (
							<div className="flex flex-col gap-2 w-full">
								<Skeleton className="p-1 "></Skeleton>
								<Skeleton className="p-1"></Skeleton>
							</div>
						) : (
							<div className="flex flex-col min-w-0">
								<span className="font-semibold text-sm truncate">
									{nameParts.join(NAME_SEPARATOR)}
								</span>
								<span className="text-xs text-muted-foreground truncate">
									{userInfo?.profile.email}
								</span>
							</div>
						)}
						<button
							type="button"
							className="p-1 ml-auto"
							aria-label="User menu"
						>
							<ChevronsUpDown className="size-4" aria-hidden="true" />
						</button>
					</div>
				</DropdownMenuTrigger>
				<DropdownMenuContent align="end">
					<DropdownMenuItem
						onClick={() => {
							logout()
							navigate({ to: "/", replace: true })
						}}
					>
						{t("sidebar.user-profile.logout")}
					</DropdownMenuItem>
				</DropdownMenuContent>
			</DropdownMenu>
		</div>
	)
}
